export type AppEnvironment = {
    REACT_APP_AUTH0_CLIENT_ID: string;
    REACT_APP_AUTH0_DOMAIN: string;
    REACT_APP_AUTH0_AUDIENCE: string;
    REACT_APP_API_URL: string;
    REACT_APP_TEALIUM_STAGE: string;
    REACT_APP_MIXPANEL_TOKEN: string;
};

export const getEnv = (): AppEnvironment =>
    ({
        REACT_APP_API_URL: process.env.REACT_APP_API_URL,
        REACT_APP_AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
        REACT_APP_AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
        REACT_APP_AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
        REACT_APP_TEALIUM_STAGE: process.env.REACT_APP_TEALIUM_STAGE,
        REACT_APP_MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
    } as AppEnvironment);
